import ButtonCard from "./ButtonCard";
import type { ComponentProps, ReactNode } from "react";

interface ButtonActionProps extends ComponentProps<typeof ButtonCard> {
  logo: ReactNode;
  tooltip?: string;
}

export default function ButtonAction({
  logo,
  tooltip,
  onClick,
  className,
  variant = "secondary",
  ...props
}: ButtonActionProps) {
  return (
    <ButtonCard
      variant={variant}
      className={className}
      onClick={onClick}
      title={tooltip}
      {...props}
    >
      {logo}
    </ButtonCard>
  );
}
